module.exports = __webpack_public_path__ + "static/media/DropZone.4b206ee5.png";